<script lang="ts" context="module">
  import {AssetService} from '../../../../services';
  const assetService = new AssetService();
  interface ImageGallery {
    loading: boolean;
    items: any[];
  }
  const imageGalleryStore = writable<ImageGallery>({
    loading: false,
    items: []
  });

  export function appendFileToGallery(file: any) {
    imageGalleryStore.update(store => ({
      ...store,
      items: [...store.items, file]
    }));
  }

  export function loadGallery() {
    imageGalleryStore.update(store => ({
      ...store,
      loading: true
    }));
    assetService.loadImages(1).then(resp => {
      imageGalleryStore.update(store => ({
        ...store,
        loading: false,
        items: resp.data?.data || [],
        hasMore: resp.data?.pagination?.hasMore || false
      }));
    });
  }
</script>

<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import GallerySearch from './GallerySearch.svelte';
  import GalleryResults from './GalleryResults.svelte';
  import ImageGalleryUpload from './ImageGalleryUpload.svelte';
  import PixabaySearch, {pixabaySearchStore} from '../../../pixabay-search/PixabaySearch.svelte';
  import PixabayResults from '../../../pixabay-search/PixabayResults.svelte';
  import {createImageElement} from '../../../../lib/editor/helpers';
  import editorInstance from '../../../../lib/editor/editor';
  import {writable} from 'svelte/store';
  let selected = 'saved';
  const unsubscribeToSearchStore = pixabaySearchStore.subscribe(store => {
    selected = store !== '' ? 'search' : 'saved';
  });
  function pixabayImageSelected(event: any) {
    console.log('Image selected', event);
    const image = event.detail.result;
    const imageEl = createImageElement(image.imageURL);
    editorInstance.addComponent(imageEl, true);
  }
  onMount(() => {
    // alert('Gallery opened');
  });

  onDestroy(() => {
    unsubscribeToSearchStore();
  });
</script>

<div class="relative flex h-full w-full flex-col">
  <div>
    <!-- <span class="img-gallery-toggle {selected == 'search' ? 'selected' : ''}" on:keydown={() => selected = 'search'} on:click={() => selected = "search"}>Search</span>
        <span class="img-gallery-toggle {selected == 'saved' ? 'selected' :''}" on:click={() => selected = 'saved'} on:keydown={() => selected = 'save'}>Saved</span> -->
  </div>
  <div class=" bg-gray-100">
    <!-- <div class="block py-2">
            <PixabaySearch />
        </div> -->
    <div class="block py-2">
      <ImageGalleryUpload />
    </div>
  </div>
  {#if selected == 'search'}
    <PixabayResults on:select={pixabayImageSelected} />
  {:else}
    <GalleryResults />
  {/if}
</div>

<style lang="postcss">
  .img-gallery-toggle {
    @apply inline-block cursor-pointer pr-3 text-sm font-bold text-slate-400;
    &.selected {
      @apply bg-transparent underline;
    }
  }
</style>
